import * as React from 'react';
import { BodyText } from '@minecraft.atoms';
import UncontrolledDropdown from '@minecraft.uncontrolled-dropdown';
import DropdownMenu from '@minecraft.dropdown-menu';
import DropdownItem from '@minecraft.dropdown-item';
import DropdownToggle from '@minecraft.dropdown-toggle';
import { WindowWidthContext } from '@minecraft.utils';
import { buildOptionalProps, DropdownItemProps, OptionalProps } from './types';
import { useDropdown } from './useDropdown';

interface BaseDropdownButtonProps extends OptionalProps {
  toggleProps: any;
  menuItemsProps: DropdownItemProps[];
  menuChildren?: React.ReactNode;
  menuAlign?: 'right' | 'left';
  block?: boolean;
  mobileBlock?: boolean;
  toggleComponent: React.ElementType;
  toggleChildren?: React.ReactNode;
  toggleExtraProps?: object;
  menuExtraProps?: object;
}

export const BaseDropdownButton = ({
  toggleProps,
  menuItemsProps,
  menuChildren,
  menuAlign,
  block,
  mobileBlock,
  toggleComponent,
  toggleChildren,
  toggleExtraProps,
  menuExtraProps,
  ...props
}: BaseDropdownButtonProps) => {
  const isMobile = WindowWidthContext.useIsMobile();
  const { ddBlockWidth, buildTestIdProps, buildQaIdProps, qaIdBase, testIdBase, className } = useDropdown(props);
  const menuItemsWithIds = menuItemsProps.filter(
    (mi) => ['number', 'string'].includes(typeof mi.id) && !!mi.id.toString()
  );
  const menuWidth = mobileBlock && isMobile ? { width: '100%' } : {};

  const wrapperFullWidth = block || (mobileBlock && isMobile) ? { width: '100%' } : {};

  return (
    <UncontrolledDropdown
      style={{ ...ddBlockWidth, ...wrapperFullWidth }}
      direction={menuAlign}
      {...buildOptionalProps({ testId: `${testIdBase}-wrapper`, qaId: `${qaIdBase}-wrapper`, className })}
    >
      <DropdownToggle
        {...buildTestIdProps(testIdBase, 'toggle')}
        {...buildQaIdProps(qaIdBase, 'toggle')}
        {...toggleProps}
        tag={toggleComponent}
        {...toggleExtraProps}
      >
        {toggleChildren}
      </DropdownToggle>
      <DropdownMenu
        style={{ ...menuWidth, maxHeight: '50vh', overflowX: 'auto' }}
        {...menuExtraProps}
        {...buildOptionalProps({ testId: `${testIdBase}-menu`, qaId: `${qaIdBase}-menu` })}
      >
        {menuItemsWithIds.map(
          ({ id, label, qaId: menuQaId, testId: menuTestId, className: menuClassName, color, ...miProps }) => (
            <DropdownItem
              key={id}
              {...miProps}
              {...buildOptionalProps({ testId: menuTestId, qaId: menuQaId, className: menuClassName })}
            >
              <BodyText color={color || 'default'}>{label}</BodyText>
            </DropdownItem>
          )
        )}
        {menuChildren}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};
